import { exportGroupedExcel } from "../../../../../utils/export/groupedExcel";
import {
  formatDate,
  formatWithCurrency,
  getDestination,
  getSupplierName,
} from "./PayablePdf";

const ITEM_COLUMNS = [
  "Product Code",
  "Product Name",
  "Unit Price",
  "Weight",
  "Moisture",
  "Net Weight",
  "Subtotal",
];

// `header` is one loaded payable (items already merged in)
function buildPayableBlockRows(header) {
  const items = header.items || [];
  const currency_name = header.currency_name;

  const rows = [
    [
      "Transaction Number",
      header.client_transaction_id || "",
      "Purchase Date",
      formatDate(header.purchaseDate),
    ],
    [
      "Supplier",
      getSupplierName(header.vendor),
      "Receiving Warehouse",
      header.warehouse?.name || "",
    ],
    [
      "Destination",
      getDestination(header.domestic_type),
      "Deadline",
      formatDate(header.dueDate),
    ],
    [
      "Total Amount",
      header.totalPrice !== undefined
        ? formatWithCurrency(header.totalPrice, currency_name)
        : "",
    ],
    [],
    ["Item List"],
    ITEM_COLUMNS,
  ];

  if (items.length > 0) {
    items.forEach((item) => {
      rows.push([
        item.productCode,
        item.productName,
        item.unitPrice !== undefined
          ? formatWithCurrency(item.unitPrice, currency_name)
          : "",
        item.weight ?? "",
        item.moisture ?? "",
        item.net_weight ?? "",
        item.totalPrice !== undefined
          ? formatWithCurrency(item.totalPrice, currency_name)
          : "",
      ]);
    });
  } else {
    rows.push(["No items"]);
  }

  // Blank spacer rows between one payable block and the next.
  rows.push([]);
  rows.push([]);

  return rows;
}

// Summary sheet + one sheet per supplier
export default function exportPayableExcel({ records, meta }) {
  return exportGroupedExcel(records, meta, {
    groupLabel: "Supplier",
    countLabel: "No. of Payables",
    getGroup: (payable) => ({
      key: payable.vendor?.id,
      name: getSupplierName(payable.vendor),
    }),
    getCurrency: (payable) => payable.currency_name,
    getAmount: (payable) => payable.totalPrice,
    buildBlockRows: buildPayableBlockRows,
  });
}
